









import { defineComponent, ref, watch } from "@vue/composition-api";

import { Token } from "@/tools/msa/models";
import { CodeMatchItem, ConceptMatchItem, Item } from "@/tools/msa/models/item";
import { calculateContextClasses } from "@/tools/msa/utils/classes";

interface Props {
  token: Token;
  items: Item[];
  selected: boolean;
}

export default defineComponent<Props>({
  name: "BaseToken",
  props: {
    token: { type: Object, required: true },
    items: { type: Array, default: () => [] },
    selected: { type: Boolean, default: false }
  },
  setup(props: Props) {
    const classes = ref<string[]>([]);

    watch(
      [() => props.items, () => props.selected],
      () => {
        classes.value = [
          ...new Set([
            ...(props.items.filter(item => item.type === "custom_match")
              .length > 0
              ? ["custom-match"]
              : []),
            ...props.items
              .filter(item => item.type === "concept_match")
              .map(item => item as ConceptMatchItem)
              .filter(item => item.match.context.assertion !== "negated")
              .map(item => `type-${item.match.concept.type}`)
              .sort()
              .slice(0, 1),
            ...props.items
              .filter(item => item.type === "code_match")
              .map(item => item as CodeMatchItem)
              .map(item => `type-${item.match.coding.type}`),
            props.selected ? ["evidence", "evidence-highlighted"] : []
          ])
        ].flat(1);
      },
      { immediate: true }
    );

    const html = `${props.token.text}${props.token.delimiter}`.replace(
      /\n/g,
      "<br>"
    );

    return { html, classes };
  }
});
